<template>
  <div class="table">
    <div class="container">
      <el-row>
        <el-button size="mini" class="btn" type="primary" @click="saveQuotationApply()" v-show="saveBtnShow">{{$t('common.save')}}</el-button>
        <!--保存-->
        <el-button size="mini" class="btn" type="primary" @click="submitQuotationApply" v-show="submitBtnShow">{{$t('common.submit')}}</el-button>
        <!--提交-->
        <el-button size="mini" class="btn" type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
        <!--关闭-->
      </el-row>
      <div class="handle-box">
        <el-form :model="applyData" :label-position="labelPosition" :rules="applyRules" ref="applyInfoForm" label-width="140px">
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('apply.no')">
                <!--单据编号-->
                <el-input class="handle-input" v-model="applyData.applyNo" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('apply.applyType')" prop="applyType">
                <!--类型-->
                <el-select v-model="applyData.applyType" :disabled="true" class="handle-input">
                  <el-option :key="index" v-for="(item,index) in applyTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="17">
              <el-form-item :label="$t('apply.subject')" prop="subject">
                <!--主题-->
                <el-input class="handle-input" v-model="applyData.subject"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('apply.shortlistedSuppliers')" prop="supplierNames">
                <!--入围供应商-->
                <el-input v-if="supFlag" class="handle-input" :disabled="true" v-model="applyData.supplierNames"></el-input>
                <el-input v-else @click.native="showSelSupplierDialog=true" class="handle-input" :readonly="true" suffix-icon="el-icon-search" v-model="applyData.supplierNames"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('apply.quotationType')" prop="quotationType">
                <!--报价类型-->
                <el-select v-model="applyData.quotationType" :disabled="supFlag" class="handle-input">
                  <el-option :key="index" v-for="(item,index) in quotationTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('common.createBy')">
                <!--创建人-->
                <el-input class="handle-input" v-model="applyData.name" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('common.createDate')">
                <!--创建日期-->
                <el-input class="handle-input" v-model="applyData.createDate" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane :label="$t('apply.lineDetail')" name="line">
          <el-row class="action-btn-row">
            <el-button size="mini" class="btn" type="primary" @click="onExport" v-if="ttQuotationApplyId!==-99999">{{$t('common.export')}}</el-button>
          </el-row>
          <!--线路报价明细-->
          <ux-grid ref="applyLineTableDataRef" :data="applyLineTableData" keep-source max-height="450" highlight-current-row show-overflow="tooltip">
            <ux-table-column align="center" title="操作" width="80">
              <template v-slot="scope">
                <i class="el-icon-edit-outline" @click="onEdit(scope)"></i>
              </template>
            </ux-table-column>
            <ux-table-column align="center" title="序号" type="index" width="60"></ux-table-column>
            <ux-table-column field="pickupPoint" :title="$t('base.pp.pickupPoint')" resizable align="center"></ux-table-column>
            <ux-table-column field="dcName" :title="$t('apply.dc')" resizable align="center"></ux-table-column>
            <ux-table-column field="temperature" :title="$t('apply.temperature')" resizable align="center">
              <template v-slot="scope">
                {{scope.row.temperature | ic("COMMON",'TEMPERATURE')}}
              </template>
            </ux-table-column>
            <ux-table-column field="transportaionMethod" :title="$t('apply.transportaionMethod')" resizable align="center">
              <template v-slot="scope">
                {{scope.row.transportaionMethod | ic("COMMON",'TRANSPORTAION_METHOD')}}
              </template>
            </ux-table-column>
            <ux-table-column field="originalSupplier" :title="$t('apply.originalSupplier')" resizable align="center"></ux-table-column>
            <ux-table-column field="originalPrice" :title="$t('apply.originalPrice')" resizable align="center"></ux-table-column>
            <ux-table-column field="unit" :title="$t('apply.unit')" resizable align="center">
              <template v-slot="scope">
                {{scope.row.unit | ic("COMMON",'UNIT')}}
              </template>
            </ux-table-column>
            <ux-table-column field="effectiveBeginDate" :title="$t('apply.effectiveBeginDate')" resizable align="center">
              <template v-slot="scope">
                {{scope.row.effectiveBeginDate | dateFormatFilter("YYYY-MM-DD")}}
              </template>
            </ux-table-column>
            <ux-table-column field="lineType" :title="$t('apply.lineType')" resizable align="center">
              <template v-slot="scope">
                {{scope.row.lineType | ic("TT_QUOTATION_APPLY_LINE",'LINE_TYPE')}}
              </template>
            </ux-table-column>
            <ux-table-column field="remarks" :title="$t('common.remarks')" resizable align="center"></ux-table-column>
          </ux-grid>
        </el-tab-pane>
        <!--附件列表-->
        <el-tab-pane :label="$t('common.attachment')" name="enclosure">
          <!--附件-->
          <el-upload v-show="showUploadFlag" style="float:left" ref="upload" action="upload" :http-request="uploadConfirm" :show-file-list="false" multiple name="file">
            <el-button slot="trigger" size="small" type="primary">{{$t('common.selectFile')}}</el-button>
            <!--选取文件-->
          </el-upload>
          <el-table :data="fileList" border highlight-current-row class="table">
            <el-table-column sortable prop="documentName" :label="$t('common.file')" min-width="130px">
              <!--文件-->
              <template slot-scope="scope">
                <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
              </template>
            </el-table-column>
            <el-table-column sortable prop="userName" :label="$t('common.createBy')" min-width="130px"></el-table-column>
            <!--创建人-->
            <el-table-column sortable prop="createDate" :label="$t('common.createDate')" min-width="130px">
              <!--创建时间-->
              <template slot-scope="scope">
                {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm")}}
              </template>
            </el-table-column>

            <el-table-column v-if="showUploadFlag" prop="tmDocumentId" min-width="130px">
              <template slot-scope="scope">
                <el-link type="primary" @click.native.prevent="deleteFile(scope.row.tmDocumentId,scope.$index,fileList)">{{$t('common.del')}}</el-link>
                <!--删除-->
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!--附件列表-->
      </el-tabs>

      <!--入围供应商选择-->
      <el-dialog :visible.sync="showSelSupplierDialog" append-to-body width="80%">
        <SelSupplier ref="supplierSelRef" @subCallMethod="selectSupplierMethod"></SelSupplier>
      </el-dialog>
      <el-dialog title="报价明细" :visible.sync="dialogEditVisible" width="80%" @close="onCancel">
        <el-table min-height="450" :data="tableData" ref="tableDataRef" border highlight-current-row class="table">
          <el-table-column min-width="100" prop="pickupPoint" :label="$t('base.pp.pickupPoint')">
            <template slot-scope="scope">
              <el-input :disabled="true" v-model="scope.row.pickupPoint">&nbsp;</el-input>
            </template>
          </el-table-column>
          <el-table-column prop="tmDcId" :label="$t('apply.dc')">
            <template slot-scope="scope">
              <el-input :disabled="true" v-model="scope.row.dcName">&nbsp;</el-input>
            </template>
          </el-table-column>
          <el-table-column prop="temperature" :label="$t('apply.temperature')">
            <template slot-scope="scope">
              <el-select :disabled="true" v-model="scope.row.temperature" class="handle-input">
                <el-option :key="index" v-for="(item,index) in temperatureList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="transportaionMethod" :label="$t('apply.transportaionMethod')">
            <template slot-scope="scope">
              <el-select :disabled="true" v-model="scope.row.transportaionMethod" class="handle-input">
                <el-option :key="index" v-for="(item,index) in transportaionMethodList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="originalSupplier" :label="$t('apply.originalSupplier')"></el-table-column>
          <el-table-column prop="originalPrice" :label="$t('apply.originalPrice')"></el-table-column>
          <el-table-column prop="unit" :label="$t('apply.unit')" :render-header="renderHeader">
            <template slot-scope="scope">
              <el-select v-model="scope.row.unit" class="handle-input">
                <el-option :key="index" v-for="(item,index) in unitList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column width="200px" prop="effectiveBeginDate" :label="$t('apply.effectiveBeginDate')" :render-header="renderHeader">
            <template slot-scope="scope">
              <el-date-picker :picker-options="dateLimit" value-format="yyyy-MM-dd" v-model="scope.row.effectiveBeginDate" type="date" style="width: 80%" :placeholder="$t('common.selDate')"></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column prop="lineType" :label="$t('apply.lineType')" width="160px" :render-header="renderHeader">
            <template slot-scope="scope">
              <el-select v-model="scope.row.lineType" class="handle-input">
                <el-option :key="index" v-for="(item,index) in lineTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="remarks" :label="$t('common.remarks')">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remarks">&nbsp;</el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="center" style="margin-top:10px;">
          <el-button type="primary" @click="onConfirm">确认</el-button>
          <el-button type="primary" @click="onCancel">取消</el-button>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { applyService } from "../../../api/quotation-apply/quotation-apply";
import { fileService } from "../../../api/common/file-utils";
import { inputChoiceService } from "../../../api/common/input-choice";
import SelSupplier from '../base-data/carrier-sel-page'
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";

let checkSubject = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请填写主题'))
  } else {
    if (value && commonFun.unicodeLength(value) > 500) {
      callback(new Error('主题内容长度为500,请精简输入'))
    } else {
      callback()
    }
  }
}
export default {
  name: 'apply-change-line',
  components: {
    SelSupplier,
  },
  data() {
    return {
      dialogEditVisible: false,
      index: null,
      tableData: [],
      ttQuotationApplyId: null,
      labelPosition: 'right',
      applyData: { quotationType: '' },
      activeName: 'line',
      applyLineTableData: [],
      applyTypeList: [],
      quotationTypeList: [],
      temperatureList: [],
      lineTypeList: [],
      transportaionMethodList: [],
      unitList: [],
      saveBtnShow: false,
      submitBtnShow: false,
      showSelSupplierDialog: false,
      showUploadFlag: false,
      applyRules: {
        supplierCodes: [
          //请选择入围供应商
          { required: true, message: this.$t('apply.selectSuppliers'), trigger: 'dbclick' }
        ],
        quotationType: [
          //请选择报价类型
          { required: true, message: this.$t('apply.selectQuotationType'), trigger: 'change' }
        ],
        subject: [
          { validator: checkSubject, trigger: 'blur' }
        ]
      },
      supplierIds: [],
      comeFrom: '',
      fileList: [],
      dateLimit: {
        disabledDate(time) {
          let nextMonth = new Date();
          nextMonth.setMonth(new Date().getMonth() + 1)
          nextMonth.setDate(1);
          return time.getTime() < nextMonth - 8.64e7; // - 8.64e7 表示可选择当天时间
        }
      },
      supFlag: false,
    }
  },
  created() {
    //来自于线路价格主数据
    this.ttQuotationApplyId = -99999;
    if (this.$route.params.source == 'SUP') {
      //供应商操作入围供应不可以选择
      this.supFlag = true;
    } else {
      this.supFlag = false;
    }
    this.applyLineChangePageInit(this.$route.params.applyId);
    this.getInputChoiceValues();
    this.getFiles();
  },
  methods: {
    // 新增线路编辑
    onEdit(scope) {
      this.dialogEditVisible = true
      this.index = scope.rowIndex
      this.tableData.push(JSON.parse(JSON.stringify(scope.row)))
    },
    onConfirm() {
      console.log('this.tableData[0]', this.tableData[0]);
      this.$refs.applyLineTableDataRef.reloadRow(this.$refs.applyLineTableDataRef.data[this.index], this.tableData[0], null)
      console.log('this.$refs.applyLineTableDataRef.data[this.index]', this.$refs.applyLineTableDataRef.data);
      this.dialogEditVisible = false
      setTimeout(() => {
        this.tableData = []
      }, 500);
    },
    onCancel() {
      this.dialogEditVisible = false
      this.tableData = []
    },
    renderHeader(h, { column, $index }) {
      return h("span", [
        h("span", { class: "mandatory" }),
        h("span", column.label)
      ]);
    },
    onExport() {
      applyService.exportDetail(this.ttQuotationApplyId).then((res) => {
        fileService.respToFile(res, 'RFQ(Line)申请单' + this.applyData.applyNo + '.xlsx');
      })
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => { })
    },
    //文件删除
    deleteFile: function (tmDocumentId, index, files) {
      fileService.deleteFile(tmDocumentId).then((res) => {
        //删除成功删除列表数据
        files.splice(index, 1);
      })
    },
    //文件列表数据获取
    getFiles: function () {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = this.ttQuotationApplyId;
      attachment.tsReckindId = 'QUOTATION_APPLY';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileList = fileRes;
      })
    },
    //文件上传
    uploadConfirm: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.documents = res.data;
        attachment.seq = '1';
        attachment.tsRecId = this.ttQuotationApplyId;
        attachment.tsReckindId = 'QUOTATION_APPLY';
        fileService.saveFile(attachment).then((saveRes) => {
          _this.getFiles();
        })
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    historyBack: function () {
      this.$router.replace({
        path: '/linePriceData'
      });
    },
    //页面初始化
    applyLineChangePageInit: function (tmLineIds) {
      applyService.getChangeLineQuotationApplyInfo(tmLineIds).then((res) => {
        this.applyData = res.quotationApply;
        this.applyLineTableData = res.quotationApplyLine;
        this.supplierIds = res.quotationApply.supplierIds;
        if (this.supFlag) {
          this.applyData.quotationType = 'SUP';
        }
        //非供应商端只能编辑代供应商的单据
        if (!!res.quotationApply.ttQuotationApplyId && res.quotationApply.status == '1' && res.quotationApply.source == 'MCD') {
          //草稿单据
          this.submitBtnShow = true;
          this.saveBtnShow = true;
          this.showUploadFlag = true;
        } else if (this.ttQuotationApplyId <= 0) {
          this.saveBtnShow = true;
        }
        this.$refs.applyLineTableDataRef.reloadData(res.quotationApplyLine)
      });
    },
    applyPageInit: function (applyId) {
      applyService.getQuotationApplyInfo(applyId).then((res) => {
        this.applyData = res.quotationApply;
        this.applyLineTableData = res.quotationApplyLine;
        this.supplierIds = res.quotationApply.supplierIds;
        this.submitBtnShow = true;
        this.saveBtnShow = true;
        this.showUploadFlag = true;
      });
    },
    //线路报价保存
    saveQuotationApply: function () {
      //判断校验是否通过
      let validFlag = false;
      this.$refs['applyInfoForm'].validate((valid) => {
        validFlag = valid;
      });
      console.log("🚀 ~ this.$refs['applyInfoForm'].validate ~ validFlag:", validFlag)
      if (!validFlag) {
        return;
      }
      // for (let i = 0; i < this.applyLineTableData.length; i++) {
      //   var item = this.applyLineTableData[i]
      //   if (!item.lineType) {
      //     this.$message({ message: "请选择线路类型", type: "warning" });
      //     return;
      //   }
      // }
      if (!!this.ttQuotationApplyId && this.ttQuotationApplyId > 0) {
        let quotationApplyInfo = {};
        quotationApplyInfo.quotationApply = this.applyData;
        quotationApplyInfo.quotationApplyLine = this.applyLineTableData;
        //修改
        applyService.updateApplyInfo(quotationApplyInfo).then((res) => {
          Message({ message: this.$t('common.saveSuccess'), type: "success" });
        })
      } else {
        //新增
        let quotationApplyInfo = {};
        quotationApplyInfo.quotationApply = this.applyData;
        quotationApplyInfo.quotationApplyLine = this.applyLineTableData;
        applyService.createLineChangeApplyInfo(quotationApplyInfo).then((res) => {
          if (res.meta.success) {
            this.ttQuotationApplyId = res.data;
            this.applyPageInit(res.data)
          }
        })
      }

    },
    //线路报价申请单提交
    submitQuotationApply: function () {
      let _this = this;
      if (!!this.ttQuotationApplyId) {
        //判断校验是否通过
        let validFlag = false;
        this.$refs['applyInfoForm'].validate((valid) => {
          validFlag = valid;
        });
        if (!validFlag) {
          return;
        }
        for (let i = 0; i < this.applyLineTableData.length; i++) {
          var item = this.applyLineTableData[i]
          if (!item.unit) {
            _this.$message({ message: "请选择结算单位", type: "warning" });
            return;
          }
          if (!item.effectiveBeginDate) {
            _this.$message({ message: "请选择有效开始日期", type: "warning" });
            return;
          }
          if (!item.lineType) {
            _this.$message({ message: "请选择线路类型", type: "warning" });
            return;
          }
        }
        _this.submitBtnShow = false;
        let quotationApplyInfo = {};
        quotationApplyInfo.quotationApply = this.applyData;
        quotationApplyInfo.quotationApplyLine = this.applyLineTableData;
        //修改
        applyService.updateApplyInfo(quotationApplyInfo).then((res) => {
          let mapObj = {};
          mapObj["applyId"] = this.ttQuotationApplyId;
          mapObj["confirm"] = 0;
          applyService.submitApplyInfo(mapObj).then((res) => {
            if (res.meta.success) {
              Message({ message: this.$t('common.saveSuccess'), type: "success" });
              _this.historyBack();
            } else {
              _this.$confirm(res.meta.msg, this.$t('common.tips'), {
                confirmButtonText: this.$t('common.confirm'),
                cancelButtonText: this.$t('common.cancel'),
                cancelButtonClass: 'el-button--primary',
                confirmButtonClass: 'el-button--primary',
                type: 'warning'
              }).then(() => {
                //用户确认后再次提交
                mapObj["confirm"] = 1;
                applyService.submitApplyInfo(mapObj).then(res => {
                  Message({ message: this.$t('common.saveSuccess'), type: "success" });
                  _this.historyBack();
                }).catch(() => {
                  _this.submitBtnShow = true;
                });
              }).catch(() => {
                _this.submitBtnShow = true;
              });
            }
          }).catch(() => {
            _this.submitBtnShow = true;
          });
        })

      }

    },
    //供应商选择
    selectSupplierMethod: function (supList) {
      let _this = this;
      let codes = new Array();
      this.supplierIds = [];
      supList.forEach(((item) => {
        _this.supplierIds.push(item.tmSupplierId);
        codes.push(item.supplierName);
      }))
      _this.applyData.supplierNames = codes.join(",");
      _this.applyData.supplierIds = _this.supplierIds;
      this.showSelSupplierDialog = false;
    },
    //下拉列表数据获取
    getInputChoiceValues: function () {
      let mapObj = {};
      mapObj["TT_QUOTATION_APPLY:APPLY_TYPE"] = "TT_QUOTATION_APPLY:APPLY_TYPE";
      mapObj["TT_QUOTATION_APPLY:QUOTATION_TYPE"] = "TT_QUOTATION_APPLY:QUOTATION_TYPE";
      mapObj["COMMON:TEMPERATURE"] = "COMMON:TEMPERATURE";
      mapObj["COMMON:TRANSPORTAION_METHOD"] = "COMMON:TRANSPORTAION_METHOD";
      mapObj["COMMON:UNIT"] = "COMMON:UNIT";
      mapObj["TT_QUOTATION_APPLY_LINE:LINE_TYPE"] = "TT_QUOTATION_APPLY_LINE:LINE_TYPE";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.applyTypeList = res["TT_QUOTATION_APPLY:APPLY_TYPE"];
        this.quotationTypeList = res["TT_QUOTATION_APPLY:QUOTATION_TYPE"];
        this.temperatureList = res["COMMON:TEMPERATURE"];
        this.transportaionMethodList = res["COMMON:TRANSPORTAION_METHOD"];
        this.unitList = res["COMMON:UNIT"];
        this.lineTypeList = res["TT_QUOTATION_APPLY_LINE:LINE_TYPE"];
      });
    },
    //清除校验信息
    clearVlidate: function (refFormName) {
      if (this.$refs[refFormName]) {
        this.$refs[refFormName].clearValidate();
      }
    },
  }
}
</script>
<style scoped>
.handle-box {
  margin-top: 5px;
  margin-bottom: 5px;
}
.handle-input {
  width: 85%;
}

.handle-input-out {
  width: 70%;
}
.action-btn {
  margin-bottom: 10px;
}
.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}
.lineClass .el-form-item__label:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
</style>